import type { AppStrings } from './types.js';

export const ms: AppStrings = {
  // COMMON
  error_title: 'Ralat',
  cancel: 'Batal',
  retry: 'Cuba lagi',
  back_arrow: '← Kembali',

  // ASK SCREEN
  ask_box_unavailable: 'Kotak tidak tersedia',
  ask_box_unavailable_desc: 'Pautan mungkin sudah lapuk atau pemilik telah menutup kotaknya.',
  ask_create_own_box: 'Buat kotak sendiri',
  ask_sent_title: 'Dihantar ✅',
  ask_sent_desc: 'Soalan tanpa nama kamu telah dihantar kepada pemilik kotak.',
  ask_anonymous_hint: 'Soalan kamu akan dihantar secara tanpa nama.',
  ask_placeholder: 'Tulis soalan kamu…',
  ask_send: 'Hantar',
  ask_sending: 'Menghantar…',
  ask_error_rate_limit: 'Terlalu banyak permintaan — sila tunggu sebentar.',
  ask_error_restart: 'Sila mulakan semula Mini App.',
  ask_error_load: 'Gagal memuatkan kotak.',
  ask_error_send: 'Gagal menghantar soalan.',
  ask_error_banned: 'Kamu disekat dalam apl ini.',
  ask_banned_appeal_btn: 'Rayuan',
  ask_appeal_sent: 'Rayuan dihantar. Kami akan semak secara manual.',

  // AGE GATE
  age_gate_title: 'Hanya 18+ sahaja',
  age_gate_desc:
    'Kamu menghantar soalan tanpa nama. Bersopan santunlah: gangguan, ugutan, kandungan seksual melibatkan kanak-kanak, dan sebarang kandungan yang melanggar undang-undang adalah dilarang. Tanpa nama bukan bermakna bebas hukuman — pelanggaran dilaporkan kepada moderasi. Dengan menghantar soalan, kamu mengesahkan kamu berusia 18+ dan menerima peraturan ini.',
  age_gate_confirm: 'Saya 18+ — teruskan',

  // INBOX SCREEN
  inbox_title: 'Kotak kamu',
  box_link_accordion: 'Pautan jemputan',
  inbox_notifications_ask: '🔔 Benarkan bot menghantar pemberitahuan tentang soalan baru?',
  inbox_notifications_allow: 'Benarkan',
  inbox_notifications_dismiss_label: 'Tolak',
  inbox_box_toggle_disable: 'Nyahdayakan soalan',
  inbox_box_toggle_enable: 'Dayakan soalan',
  inbox_box_disabled_warning: 'Soalan dinyahdayakan — tiada soalan baru yang akan diterima.',
  inbox_share_hint: 'Kongsi pautan supaya rakan-rakan boleh bertanya soalan tanpa nama kepada kamu.',
  inbox_copy: 'Salin',
  inbox_copied: 'Disalin',
  inbox_copy_error: 'Ralat',
  inbox_no_deeplink: 'Pautan akan muncul selepas deploy.',
  inbox_invite_story: 'Jemput melalui Story',
  inbox_invite_chat: 'Jemput melalui chat',
  inbox_card_rendering: 'Kad jemputan sedang dirender.',
  inbox_story_unsupported:
    'Story tidak tersedia dalam versi Telegram ini. Cuba "melalui chat".',
  inbox_story_error: 'Gagal membuka Story.',
  inbox_chat_unsupported:
    'Perkongsian chat tidak tersedia dalam versi Telegram ini. Kemas kini klien kamu.',
  inbox_chat_error: 'Gagal berkongsi. Sila cuba lagi.',
  inbox_chat_prepare_error: 'Gagal menyediakan jemputan.',
  inbox_filter_incoming: 'Masuk',
  inbox_filter_hidden: 'Tersembunyi',
  inbox_filter_blocked: 'Disekat',
  inbox_filter_empty: 'Tiada apa di sini lagi.',
  inbox_acc_unanswered: 'Belum dijawab',
  inbox_acc_answered: 'Dijawab',
  inbox_acc_hidden: 'Tersembunyi',
  inbox_acc_blocked: 'Disekat',
  inbox_empty: 'Tiada soalan lagi. Kongsi pautan di atas.',
  inbox_load_more: 'Muatkan lagi',
  inbox_load_more_error: 'Gagal memuatkan halaman seterusnya.',
  inbox_error_load: 'Gagal memuatkan kotak.',
  inbox_rate_limit: 'Terlalu banyak permintaan — sila tunggu sebentar.',
  inbox_toggle_error: 'Gagal menukar status kotak.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Tulis kepada saya secara tanpa nama',
  message_placeholder: 'Tulis mesej…',
  message_anonymous_hint: 'Mesej kamu akan dihantar secara tanpa nama.',
  message_sent_title: 'Dihantar ✅',
  message_sent_desc: 'Mesej tanpa nama kamu telah dihantar.',
  message_owner_entry: 'Tulis kepada saya',
  message_share_hint: 'Kongsi pautan supaya sesiapa sahaja boleh menghantar mesej tanpa nama kepada kamu.',
  message_inbox_open: 'Mesej diterima',
  message_inbox_title: 'Mesej',
  message_inbox_empty: 'Tiada mesej lagi. Kongsi pautan kamu di atas.',

  // ANSWER SCREEN
  answer_title: 'Jawab soalan',
  answer_placeholder: 'Tulis jawapan kamu…',
  answer_submit: 'Hantar',
  answer_submitting: 'Menghantar…',
  answer_back: 'Kembali',
  answer_error_send: 'Gagal menghantar jawapan.',

  // SHARE SCREEN
  share_title: 'Jawapan diterbitkan ✅',
  share_hint: 'Kongsi kad ini dan kumpul lebih banyak soalan.',
  share_card_rendering_desc:
    'Kad masih dirender. Kembali ke soalan dan semak sebentar lagi — kamu boleh kongsikannya dalam Story atau chat.',
  share_card_alt: 'Kad jawapan',
  share_story_btn: 'Kongsi ke Story',
  share_story_btn_busy: 'Membuka…',
  share_chat_btn: 'Kongsi ke chat',
  share_chat_btn_busy: 'Menyediakan…',
  share_back: 'Kembali ke soalan',
  share_story_unsupported:
    'Story tidak tersedia dalam versi Telegram ini. Cuba "Kongsi ke chat".',
  share_story_error: 'Gagal membuka Story. Cuba "Kongsi ke chat".',
  share_chat_sent: 'Mesej dihantar.',
  share_chat_unsupported:
    'Perkongsian chat tidak tersedia dalam versi Telegram ini. Kemas kini klien kamu.',
  share_chat_error: 'Gagal berkongsi. Sila cuba lagi.',
  share_chat_prepare_error: 'Gagal menyediakan mesej.',

  // LEADERBOARD SCREEN
  lb_title: 'Papan Pendahulu',
  lb_period_7d: '7 hari',
  lb_period_30d: '30 hari',
  lb_period_all: 'Sepanjang masa',
  lb_group_label: 'Kategori',
  lb_group_all: 'Semua',
  lb_group_ask: 'Tanya',
  lb_group_rate: 'Nilai',
  lb_group_confession: 'Pengakuan',
  lb_group_guesswho: 'Teka Siapa',
  lb_group_message: 'Mesej',
  lb_error: 'Gagal memuatkan papan pendahulu',
  lb_empty: 'Tiada siapa dalam ranking lagi',
  lb_anon: 'Tanpa Nama',
  lb_load_more: 'Muatkan lagi',
  lb_questions: (n) => `${n} soalan`,
  lb_referrals: (n) => `${n} rujukan`,

  // REWARDS SCREEN
  rw_title: 'Ganjaran saya',
  rw_error: 'Gagal memuatkan ganjaran',
  rw_level: (n) => `Tahap ${n}`,
  rw_confirmed_referrals: (n) => `${n} rujukan disahkan`,
  rw_next_level_section: (n) => `TAHAP SETERUSNYA — ${n} rujukan`,
  rw_to_level: (level, target) => `ke tahap ${level}: ${target}`,
  rw_max_level: 'Tahap maksimum dicapai!',
  rw_badges_section: 'LENCANA',
  rw_formats_section: 'FORMAT KOTAK',

  // QUESTION CARD
  qcard_status_new: 'Baru',
  qcard_status_hidden: 'Tersembunyi',
  qcard_status_answered: 'Dijawab',
  qcard_moderation_flagged: 'Perhatian: mesej mencurigakan',
  qcard_answer_btn: 'Jawab',
  qcard_answer_send: 'Hantar',
  qcard_share_btn: 'Kongsi',
  qcard_hide_btn: 'Sembunyikan',
  qcard_show_btn: 'Tunjukkan',
  qcard_report_btn: 'Laporkan',
  qcard_block_btn: 'Sekat',
  qcard_unblock_btn: 'Buka sekatan',
  qcard_report_reason_label: 'Pilih sebab laporan:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Gangguan',
  qcard_reason_sexual: 'Kandungan seksual',
  qcard_reason_other: 'Lain-lain',
  qcard_error_hide: 'Gagal mengubah keterlihatan.',
  qcard_error_report: 'Gagal menghantar laporan.',
  qcard_error_block: 'Gagal menyekat penghantar.',
  qcard_report_done: 'Laporan dihantar — terima kasih.',
  qcard_block_done: 'Penghantar disekat.',
  qcard_unblock_done: 'Sekatan penghantar dibuka.',

  // ERRORS
  err_network: 'Tiada sambungan ke pelayan. Semak internet kamu dan cuba lagi.',
  err_server_unavailable: 'Pelayan tidak tersedia buat sementara, sila cuba lagi nanti.',
  err_internal: 'Ada sesuatu yang tidak kena. Kami sedang menyiasinya — cuba lagi nanti.',
  err_bad_request: 'Sila semak data yang kamu masukkan.',
  err_generic: 'Tindakan tidak dapat diselesaikan, sila cuba lagi nanti.',
  err_schema: 'Ralat data. Cuba kemas kini apl.',
  share_story_link_premium_note:
    'Pautan boleh klik dalam Story memerlukan Telegram Premium. Tanpanya rakan-rakan masih boleh jumpa kamu — nama pengguna kamu tertera pada kad.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Ralat akses',
  auth_error_desc:
    'Pengesahan gagal. Sila tutup dan buka semula Mini App daripada Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Ganjaran baru!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Soalan',
  tab_leaderboard: 'Papan Pendahulu',
  tab_rewards: 'Ganjaran',
  tab_settings: 'Tetapan',

  // SETTINGS SCREEN
  settings_title: 'Tetapan',
  settings_section_general: 'Umum',
  settings_notifications: 'Pemberitahuan soalan baru',
  settings_notifications_hint: 'Bot akan menghantar mesej apabila seseorang bertanya soalan.',
  settings_notifications_error: 'Gagal menyimpan tetapan pemberitahuan.',
  settings_language: 'Bahasa',
  settings_language_error: 'Tidak dapat menukar bahasa. Sila cuba lagi.',
  settings_section_about: 'Tentang',
  settings_version: 'Versi',

  // CODE ENTRY
  code_modal_title: 'Pautan Story hanya untuk Premium',
  code_modal_explain:
    'Telegram hanya memberikan pautan boleh klik dalam story kepada pelanggan Premium. Sebaliknya, tambahkan kod kamu dalam story — pengunjung menaipnya dalam apl dan bertanya soalan tanpa nama kepada kamu.',
  code_modal_your_code: 'Kod kamu',
  code_modal_copy: 'Salin kod',
  code_modal_copied: 'Disalin',
  code_modal_share_btn: 'Kongsi ke story',
  code_modal_loading: 'Mendapatkan kod kamu…',
  code_modal_error: 'Tidak dapat mendapatkan kod kamu. Cuba lagi nanti.',
  ask_code_title: 'Masukkan kod',
  ask_code_desc:
    'Datang dari story? Cari kod di dalamnya (cth. 1234) dan taip di bawah.',
  ask_code_placeholder: 'Kod dari story',
  ask_code_find: 'Cari',
  ask_code_not_found: 'Kod tidak dijumpai. Semak digit dan cuba lagi.',
  ask_code_invalid: 'Kod terdiri daripada 4 digit.',
  code_onboarding_header: 'Datang dari story?',
  code_onboarding_text: 'Masukkan kod rakan untuk bertanya soalan tanpa nama kepada mereka.',
  code_onboarding_action: 'Masukkan kod',
  settings_ask_by_code: 'Tanya dengan kod',
  settings_my_code_title: 'Kod story kamu',
  settings_my_code_hint:
    'Tulis kod ini dalam story kamu — pengunjung menaipnya untuk bertanya soalan tanpa nama. Telegram hanya memberikan pautan boleh klik dalam story kepada pelanggan Premium.',
  settings_my_code_rotate: 'Dapatkan kod baru',
  settings_my_code_rotating: 'Mengemas kini…',
  settings_my_code_done: 'Kod dikemas kini',
  settings_my_code_error: 'Tidak dapat mendapatkan kod kamu.',
  settings_my_code_rotate_confirm_title: 'Tukar kod kamu?',
  settings_my_code_rotate_confirm_desc:
    'Kod lama kamu terus berhenti berfungsi. Sesiapa yang nampak kod itu di story kamu tak dapat lagi hubungi kamu. Tukar cuma kalau ada orang ganggu kamu.',
  settings_my_code_rotate_confirm_action: 'Tukar kod',

  // BOT
  bot_greeting: (name) => (name ? `Hai, ${name}! 👋` : 'Hai! 👋'),
  bot_onboarding:
    'Ini adalah VeylMe — soalan tanpa nama.\n\n' +
    'Buka Mini App, paparkan kad «Tanya saya secara tanpa nama» di Story kamu — ' +
    'dan terima soalan tanpa nama terus di sini.\n\n' +
    '⚠️ 18+. Bersikap hormat: buli, ugutan dan kandungan yang dilarang ' +
    'tidak dibenarkan. Anonimiti ≠ kekebalan — pelanggaran dilaporkan kepada moderasi.',
  bot_open_btn: 'Buka VeylMe',
  notify_answer_btn: 'Jawab',
  bot_invite_text:
    'Seseorang telah berkongsi pautan VeylMe.\n\n' +
    'Buka Mini App untuk bertanya secara tanpa nama:',
  bot_invite_btn: 'Tanya secara tanpa nama',

  // WORK-027 i18n sweep
  tagline: 'Tanya saya secara tanpa nama',
  share_ask_action: 'Tanya',
  share_answered_text: 'Saya menjawab soalan tanpa nama 👀',
  err_not_in_telegram: 'Mini App tidak berjalan dalam Telegram. Sila mulakan semula apl.',
  badge_viral_starter: 'Permulaan viral',
  badge_storyteller: 'Pencerita',
  badge_loop_master: 'Tuan gelung',
  theme_confession: 'Pengakuan',
  theme_guesswho: 'Teka Siapa',
  rw_format_named: (name) => `format «${name}»`,
  card_label_question: 'Soalan',
  card_label_answer: 'Jawapan',
  card_invite_subtitle: 'tanpa nama, tiada pendaftaran',
  card_code_hint: 'MASUKKAN KOD DALAM APL',
  share_msg_title: (brand) => `${brand} · Soalan tanpa nama`,
  notify_new_question: '🔔 Seseorang bertanya soalan tanpa nama kepada anda',
  notify_unanswered_reminder: (n) => `🔔 Anda mempunyai ${n} soalan belum dijawab`,
  notify_ban_permanent: 'secara kekal',
  notify_ban_until: (date) => `sehingga ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Kamu disekat dalam VeylMe ${untilPhrase}. Terlalu ramai penerima melaporkan mesej kamu.\nJika kamu rasa ini adalah kesilapan, kamu boleh menghantar rayuan dalam apl.`,
  notify_warning_msg:
    '⚠️ Beberapa penerima melaporkan mesej kamu. Sedikit lagi dan kamu akan disekat dalam VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Soalan saya',
  my_questions_empty_title: 'Kamu belum bertanya soalan lagi',
  my_questions_empty_desc: 'Tanya soalan dalam peti seseorang — jawapan akan muncul di sini.',
  my_questions_loading: 'Menyemak jawapan…',
  my_questions_waiting: 'Menunggu jawapan',
  my_questions_answer_label: 'Jawapan',
  settings_my_questions: 'Soalan saya',
  ask_sent_find_reply_hint: 'Kamu boleh cari jawapan itu kemudian dalam «Soalan saya».',
  inbox_story_nonpremium_hint: 'Pautan Story tidak boleh diklik tanpa Telegram Premium, jadi kod ditunjukkan — berkongsi dalam chat lebih boleh dipercayai.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Pas Telegram kamu sudah tamat tempoh',
  session_expired_desc: 'Telegram memberi aplikasi pas sekali sahaja semasa dibuka, dan pas ini sudah tamat tempoh. Buka aplikasi semula — teks yang kamu mula sudah kami simpan.',
  session_expired_desc_no_storage: 'Pas Telegram anda sudah luput dan aplikasi perlu dibuka semula. Kami tidak dapat menyimpan teks yang anda taip — salin dahulu sebelum anda keluar.',
  session_expired_reopen: 'Buka semula',
  session_expired_stuck_title: 'Telegram memulangkan pas lama yang sama',
  session_expired_stuck_desc: 'Tutup aplikasi sepenuhnya melalui menu bot dan buka semula — barulah Telegram memberi pas baharu.',
  session_auth_failed_title: 'Log masuk tidak dapat disahkan',
  session_auth_failed_desc: 'Telegram tidak mengesahkan log masuk kamu ke aplikasi. Tutup aplikasi dan buka semula dari chat dengan bot.',
  session_expired_manual_close: 'Aplikasi tidak boleh menutup dirinya sendiri di sini — tutup sendiri dan buka semula dari chat dengan bot.',
  session_expiring_soon: 'Pas Telegram akan tamat tempoh tidak lama lagi. Buka aplikasi semula supaya tiada apa-apa hilang.',
  my_questions_check_failed: 'Jawapan tidak dapat disemak. Cuba lagi nanti.',
  settings_notifications_load_error: 'Tetapan tidak dapat dimuatkan.',
};
